// Models
/** Extension fields for the loop details */ export class MarsPlannerLoopDetailsExtensions {
    constructor(pageId, loopPageShareUrl){
        this.pageId = pageId;
        this.loopPageShareUrl = loopPageShareUrl;
    }
}
